import { createRoot } from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";
import ErrorBoundaryWrapper from "./Utils/ErrorBoundaryWrapper";
import { ModalProvider } from "./Context/ModalContext";
import { CoinProvider } from "./Context/CoinContext";
import { OrderProvider } from "./Context/OrderContext";
import { WebSocketProvider } from "./Context/WebSocketContext";
import "./Utils/axiosConfig";

const root = document.getElementById("root");
const reactRoot = createRoot(root);

reactRoot.render(
  <ErrorBoundaryWrapper>
    <Provider store={store}>
      <CoinProvider>
        <WebSocketProvider>
          <ModalProvider>
            {/* <OrderProvider> */}
            <App />
            {/* </OrderProvider> */}
          </ModalProvider>
        </WebSocketProvider>
      </CoinProvider>
    </Provider>
  </ErrorBoundaryWrapper>
);
